/// <reference path="../_references.ts"/>

module App.Helpers {
	export class PermissionService {
		public static $inject = ['$location', 'LoginService'];
		public static Factory() {
			let instance = function($location: ng.ILocationService, LoginService: App.Login.LoginService) {
				return new PermissionService($location, LoginService);
			};
			instance.$inject = PermissionService.$inject;
			return instance;
		}

		constructor(
			protected $location: ng.ILocationService,
			protected LoginService: App.Login.LoginService
		) {}

		public isUserReady() {
			return Boolean(this.LoginService.giveUserData());
		}

		public hasPermission(permission: string) {
			if (this.$location.search().office) {
				// TODO: only overwrite the permission if it is in the approved list of permissions
				permission = 'web.office.service-requests.service-request.tech-view';
			}

			let user = this.LoginService.giveUserData();

			return user && (
				(user.role && user.role.id === 2) ||
				user.permissions.indexOf(permission) !== -1
			);
		}

		public hasAnyPermission(permissions: string[]) {
			for(let permission of permissions) {
				if (this.hasPermission(permission)) {
					return true;
				}
			}

			return false;
		}

		public hasAllPermission(permissions: string[]) {
			for(let permission of permissions) {
				if (!this.hasPermission(permission)) {
					return false;
				}
			}

			return true;
		}
	}

	abstract class BasePermissionDirective implements ng.IDirective {
		static $inject = ['PermissionService', '$timeout'];

		public restrict: string = 'A';
		constructor(
			protected PermissionService: PermissionService,
			protected $timeout: ng.ITimeoutService,
			private attribute: string
		) { }

		public hasPermission(permission: string) {
			return this.PermissionService.hasPermission(permission);
		}

		public link($scope: ng.IScope, $element: ng.IAugmentedJQuery, $attributes: ng.IAttributes) {
			if (!this.PermissionService.isUserReady()) {
				this.disable($element);
				this.$timeout(this.link.bind(this, $scope, $element, $attributes), 200);
				return;
			}

			this.callEvaluate($scope.$eval($attributes[this.attribute]), $element);

			$scope.$watch(
				$attributes[this.attribute],
				(newValue, oldValue) => {
					if (newValue === oldValue) {
						return;
					}
					this.callEvaluate(newValue, $element);
				}
			);
		}

		private callEvaluate(value: {}|undefined|null, $element: ng.IAugmentedJQuery) {
			if (value === undefined) {
				return;
			} else if (!(value instanceof Array)) {
				value = [value];
			}

			this.evaluate(<string[]>value, $element);
		}

		protected abstract evaluate(value: string[], $element: ng.IAugmentedJQuery): void;
		protected abstract disable($element: ng.IAugmentedJQuery): void;
	}

	export class PermissionDirective extends BasePermissionDirective {
		public priority: number = 100;
		constructor(PermissionService: PermissionService, $timeout: ng.ITimeoutService) { super(PermissionService, $timeout, 'permission'); }

		protected disable($element: ng.IAugmentedJQuery) {
			$element.css('display', 'none');
		}

		protected evaluate(value: string[], $element: ng.IAugmentedJQuery) {
			for (let i = value.length - 1; i >= 0; --i) {
				if (this.hasPermission(value[i])) {
					$element.css('display', '');
					return;
				}
			}

			$element.css('display', 'none');
			$element.html('');
			$element.replaceWith('');
		}

		public static Factory() {
			let instance = function(PermissionService: PermissionService, $timeout: ng.ITimeoutService) {
				return new PermissionDirective(PermissionService, $timeout);
			}
			instance.$inject = PermissionDirective.$inject;
			return instance;
		}
	}

	export class WritePermissionDirective extends BasePermissionDirective {
		public priority: number = 99;
		constructor(PermissionService: PermissionService, $timeout: ng.ITimeoutService) { super(PermissionService, $timeout, 'write-permission'); }

		protected disable($element: ng.IAugmentedJQuery) {
			$element.css('disabled', 'true');
		}

		protected evaluate(value: string[], $element: ng.IAugmentedJQuery) {
			for (let i = value.length - 1; i >= 0; --i) {
				if (this.hasPermission('api.' + value[i] + '.write')) {
					$element.attr('disabled', 'false');
					return;
				}
			}

			$element.attr('disabled', 'true');
		}

		public static Factory() {
			let instance = function(PermissionService: PermissionService, $timeout: ng.ITimeoutService) {
				return new WritePermissionDirective(PermissionService, $timeout);
			}
			instance.$inject = WritePermissionDirective.$inject;
			return instance;
		}
	}

	angular
		.module('helpers.permission', ['login'])
		.service('PermissionService', PermissionService.Factory())
		.directive('permission', ['PermissionService', '$timeout', PermissionDirective.Factory()])
		.directive('writePermission', ['PermissionService', '$timeout', WritePermissionDirective.Factory()]);
}